<template>
    <div class="ablitySet">
        <h1>能力设置</h1>
        <div class="ablityTable">
            <div class="btns">
                <a-button @click="addAblity()" type="primary" class="addAblity" icon="plus">添加能力</a-button>
            </div>
            <a-table
                    :columns="columns"
                    rowKey="id"
                    :loading="loading"
                    :dataSource="dataSource"
                    :pagination="{
                        current: pageIndex,
                        pageSize: pageSize,
                        total: total,
                        showSizeChanger: true,
                        showLessItems: true,
                        showQuickJumper: true,
                        showTotal: (total, range) => `第 ${range[0]}-${range[1]} 条，总计 ${total} 条`,
                    }"
            >
                <div slot="action" slot-scope="text, record">
                    <a @click="editAbility(record)" style="margin-left: 15px">
                        <a-icon type="edit"/>
                        编辑</a>
                    <a-popconfirm title="确定删除？" ok-text="确定" cancel-text="取消" @confirm="deleteRecord(record)"
                                  style="margin-left: 15px">
                        <a style="color: #f00;">
                            <a-icon type="delete"/>
                            删除
                        </a>
                    </a-popconfirm>
                </div>
            </a-table>
        </div>
        <!-- 编辑添加能力 -->
        <a-modal v-model="isAbility" :title="modelTit" @ok="addAbilityOk">
            <a-form-model
                    ref="ruleForm"
                    :model="abilityForm"
                    :rules="abilityRules"
                    :label-col="{span:6}"
                    :wrapper-col="{span:14}"
            >
                <a-form-model-item ref="abilityTypeId" label="能力类型" prop="abilityTypeId">
                    <a-select v-model="abilityForm.abilityTypeId" placeholder="请选择能力类型" @change="abilityTypeChange">
                        <a-select-option :value="item.id" :text="item.name" v-for="item in abilityType" :key="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item ref="firstAbilityId" label="一级能力" prop="firstAbilityId">
                    <a-select v-model="abilityForm.firstAbilityId" placeholder="请选择一级能力" @change="firstAbilityChange">
                        <a-select-option :value="item.id" :text="item.name" v-for="item in firstAbility" :key="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
                <a-form-model-item ref="secondAbilityId" label="二级能力" prop="secondAbilityId">
                    <a-select v-model="abilityForm.secondAbilityId" placeholder="请选择二级能力" @change="secondAbilityChange">
                        <a-select-option :value="item.id" :text="item.name" v-for="item in secondAbility"
                                         :key="item.id">
                            {{item.name}}
                        </a-select-option>
                    </a-select>
                </a-form-model-item>
            </a-form-model>
        </a-modal>
    </div>
</template>

<script>
    const columns = [
        {title: "能力类型", dataIndex: "abilityTypeName", align: "center"},
        {title: "一级能力", dataIndex: "firstAbilityName", align: "center"},
        {title: "二级能力", dataIndex: "secondAbilityName", align: "center"},
        {title: "操作", scopedSlots: {customRender: "action"}, align: "center"}
    ];
    export default {
        name: "ablitySet",
        data() {
            return {
                type: '',//添加、编辑
                columns: columns,
                loading: false,
                dataSource: [],
                pageIndex: 1,
                pageSize: 10,
                total: 0,
                isAbility: false,//是否显示添加编辑弹窗
                // 添加编辑表单
                abilityForm: {
                    contentId: '',//当前内容id
                    abilityTypeId: '',//能力类型id
                    abilityTypeName: '',//能力类型名称
                    firstAbilityId: '',//一级能力id
                    firstAbilityName: '',//一级能力名称
                    secondAbilityId: '',//二级能力id
                    secondAbilityName: '',//二级能力名称
                    scientificName: ' ',//科学名称
                    roughDescription: ' ',//粗分说明
                },
                // 添加编辑表单验证
                abilityRules: {
                    abilityTypeId: [{required: true, message: '请选择能力类型', trigger: 'change'}],
                    firstAbilityId: [{required: true, message: '请选择一级能力', trigger: 'change'}],
                    secondAbilityId: [{required: true, message: '请选择二级能力', trigger: 'change'}],
                },
                abilityType: [],//能力类型数据
                firstAbility: [],//一级能力数据
                secondAbility: [],//二级能力数据
                modelTit: '',//弹窗title
                currentId: this.$store.getters["content/getTrainGameInfo"]().id,//当前游戏id
            };
        },
        watch: {
            isAbility() {
                if (!this.isAbility) {
                    this.$refs.ruleForm.resetFields();
                }
            }
        },
        created() {
            // 获取能力类型数据
            this.abilityTypeSelect(0)
            //获取能力表格数据
            this.getAbilityListByContentId()
        },
        methods: {
            //获取能力表格数据
            getAbilityListByContentId() {
                let params = {
                    ContentId: this.currentId
                };
                this.$http.getAbilityListByContentId(params)
                    .then(res => {
                            this.dataSource = res.data.data
                    });
            },
            // 获取能力类型数据
            abilityTypeSelect(level) {
                let params = {
                    level: level,
                    abilityType:0
                };
                this.$http.abilitySelect(params)
                    .then(res => {
                            this.abilityType = res.data.data
                    });
            },
            // 获取一级能力数据
            firstAbilitySelect(id) {
                let params = {
                    pid: id,
                    abilityType:0
                };
                this.$http.abilitySelect(params)
                    .then(res => {
                            this.firstAbility = res.data.data
                    });
            },
            // 获取二级能力数据
            secondAbilitySelect(id) {
                let params = {
                    pid: id,
                    abilityType:0
                };
                this.$http.abilitySelect(params)
                    .then(res => {
                            this.secondAbility = res.data.data
                    });
            },
            // 选中能力类型
            abilityTypeChange(value, option) {
                this.abilityForm.firstAbilityId = ''
                this.abilityForm.secondAbilityId = ''
                this.abilityForm.abilityTypeName = option.data.attrs.text
                this.firstAbilitySelect(value)
                this.secondAbility = []
            },
            // 选中一级能力
            firstAbilityChange(value, option) {
                this.abilityForm.secondAbilityId = ''
                this.abilityForm.firstAbilityName = option.data.attrs.text
                this.secondAbilitySelect(value)
            },
            // 选中二级能力
            secondAbilityChange(value, option) {
                this.abilityForm.secondAbilityName = option.data.attrs.text
            },
            // 新增打开弹窗
            addAblity() {
                this.isAbility = true
                this.type = 'add'
                this.modelTit = '添加能力'
                this.firstAbility = [],//一级能力数据
                this.secondAbility = [],
                this.abilityForm = {
                    contentId: '',//当前内容id
                    abilityTypeId: '',//能力类型id
                    abilityTypeName: '',//能力类型名称
                    firstAbilityId: '',//一级能力id
                    firstAbilityName: '',//一级能力名称
                    secondAbilityId: '',//二级能力id
                    secondAbilityName: '',//二级能力名称
                    scientificName: ' ',//科学名称
                    roughDescription: ' ',//粗分说明
                };
            },
            // 编辑打开弹窗
            editAbility(record) {
                this.type = 'edit'
                this.modelTit = '编辑能力'
                this.isAbility = true
                this.firstAbilitySelect(record.abilityTypeId)
                this.secondAbilitySelect(record.firstAbilityId)
                for (let key in record) {
                    for (let k in this.abilityForm) {
                        if (key == k) {
                            this.abilityForm[key] = record[key]
                        }
                    }
                }
                this.abilityForm.id = record.id
            },
            // 保存
            addAbilityOk() {
                this.$refs.ruleForm.validate(valid => {
                    if (valid) {
                        this.abilityForm.contentId = this.currentId

                        if (this.type == 'add') {
                            // 添加
                            this.$http.addAbility(this.abilityForm)
                                .then(res => {
                                        this.isAbility = false
                                        this.$message.destroy();
                                        this.$message.success('添加成功');
                                        this.getAbilityListByContentId()
                                    
                                });
                        } else {
                            // 编辑
                            this.$http.updataAbility(this.abilityForm)
                                .then(res => {
                                        this.isAbility = false
                                        this.$message.destroy();
                                        this.$message.success('修改成功');
                                        this.getAbilityListByContentId()
                                   
                                });
                        }
                    } else {
                        console.log('error submit!!');
                        return false;
                    }
                });
            },
            // 删除
            deleteRecord(record) {
                let formData = new FormData()
                formData.append('id', record.id)
                this.$http.deleteAbility(formData)
                    .then(res => {
                            this.$message.success('删除成功');
                            this.getAbilityListByContentId()
                       
                    });
            }
        }
    };
</script>

<style scoped lang="less">
    .ablitySet {
        width: 100%;
        h1 {
            font-size: 20px;
            font-weight: 600;
            color: rgba(0, 0, 0, 0.85);
        }
        .btns {
            width: 100%;
            display: flex;
            justify-content: flex-end;
        }
    }
</style>
